import { render, staticRenderFns } from "./VehicleAppraisalModal.vue?vue&type=template&id=5539f34a&scoped=true"
import script from "./VehicleAppraisalModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./VehicleAppraisalModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./VehicleAppraisalModal.vue?vue&type=style&index=0&id=5539f34a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5539f34a",
  null
  
)

export default component.exports